import React from "react";

import Poster from "./images/Poster.svg";
import "./OsmosisPosterStyles.scss";
import { FullscreenModal } from "@learningblocks/storybook-components";

export interface OsmosisPosterProps {
  show: boolean;
  close: () => void;
}

type ModalState = object;

export class OsmosisPoster extends React.Component<
  OsmosisPosterProps,
  ModalState
> {
  constructor(props: OsmosisPosterProps) {
    super(props);
  }

  render() {
    return (
      <FullscreenModal
        className="modalContainer"
        isOpen={this.props.show}
        closeButton={true}
        notebookExpanded={false}
        close={this.props.close}
        backLabel={"Lab"}
      >
        <div
          aria-label="Lab goal: Using dialysis tubes that contain a solution of known molarity, determine the concentration of 6 mystery sucrose solutions (possibilities include: 0.0 M, 0.2 M, 0.4 M, 0.6 M, 0.8 M, and 1.0 M)"
          className={"Poster"}
        >
          <img src={Poster} alt="Poster" />
        </div>
      </FullscreenModal>
    );
  }
}

export default OsmosisPoster;
